module.exports = __webpack_public_path__ + "static/aman-review-f465740b52de57e66bc41a7823433c7e.png";